import { defineStore } from 'pinia'
import { ref } from 'vue'

export type MapStatusFilter = 'all' | 'active' | 'inactive'
export type MapCourseFilter = 'all' | 'on_course' | 'off_course'

export const useUiStore = defineStore(
  'ui-store',
  () => {
    const showSuperAdminMenu = ref<boolean>(false)
    const mapStyle = ref<string>('mapbox://styles/mapbox/streets-v12')
    const isSidebarOpen = ref<boolean>(true)
    const is3DEnabled = ref<boolean>(false)
    const isClusteringEnabled = ref<boolean>(false)
    // Pace-of-play marker colours. Beta feature, on by default, switched from the map toolbar.
    const isPaceColorsEnabled = ref<boolean>(true)
    const showFrontSide = ref<boolean>(false)
    const isMapSidebarCollapsed = ref<boolean>(false)
    // Map page quick filters, persisted so the view comes back as the user left it
    const mapStatusFilter = ref<MapStatusFilter>('all')
    const mapCourseFilter = ref<MapCourseFilter>('all')

    function toggleSuperAdminMenu(status: boolean) {
      showSuperAdminMenu.value = status
    }

    function setMapStyle(style: string) {
      mapStyle.value = style
    }

    function setIsSidebarOpen(open: boolean) {
      isSidebarOpen.value = open
    }

    function setIs3DEnabled(enabled: boolean) {
      is3DEnabled.value = enabled
    }

    function setIsClusteringEnabled(enabled: boolean) {
      isClusteringEnabled.value = enabled
    }

    function setIsPaceColorsEnabled(enabled: boolean) {
      isPaceColorsEnabled.value = enabled
    }

    function setShowFrontSide(enabled: boolean) {
      showFrontSide.value = enabled
    }

    function setIsMapSidebarCollapsed(collapsed: boolean) {
      isMapSidebarCollapsed.value = collapsed
    }

    return {
      showSuperAdminMenu,
      toggleSuperAdminMenu,
      mapStyle,
      setMapStyle,
      isSidebarOpen,
      setIsSidebarOpen,
      is3DEnabled,
      setIs3DEnabled,
      isClusteringEnabled,
      setIsClusteringEnabled,
      isPaceColorsEnabled,
      setIsPaceColorsEnabled,
      showFrontSide,
      setShowFrontSide,
      isMapSidebarCollapsed,
      setIsMapSidebarCollapsed,
      mapStatusFilter,
      mapCourseFilter,
    }
  },
  {
    persist: true,
  },
)
